import { useAppSelector } from '@/redux/store';
import { useGetOrganizationQuery } from '@/redux/slices/organizationApiSlice';

const useIntegrationProvider = () => {
  // Use useAppSelector directly to avoid error during logout when loggedUser becomes null
  const organizationId =
    useAppSelector(state => state.loggedUser?.organizationId) || '';

  const { hrisIntegrationId, provider, isLoadingProvider } =
    useGetOrganizationQuery(organizationId, {
      skip: !organizationId,
      selectFromResult: ({ data, isFetching }) => ({
        hrisIntegrationId: data?.hrisIntegration?.id,
        provider: data?.hrisIntegration?.hrisProvider,
        // Only show loading when we have no data yet (initial load). Background refetches (e.g. polling
        // in AsyncIntegrationSetupBanner) should not disable the Sync button or cause UI blink.
        isLoadingProvider: isFetching && !data,
      }),
    });

  return {
    hrisIntegrationId,
    provider,
    isLoadingProvider,
  };
};

export default useIntegrationProvider;
